import React from 'react';
import { Text } from '@/components/typography';
import { useTranslations } from 'next-intl';

export interface FeedbackErrorProps {
  error?: string;
}

const FeedbackError = ({ error }: FeedbackErrorProps) => {
  const t = useTranslations('FormValidation');

  let messageI18n;
  switch (error) {
    case 'Required':
    case 'Preenchimento obrigatório.':
      messageI18n = t('Preenchimento obrigatório');
      break;
    case 'Informe um endereço de e-mail válido.':
      messageI18n = t('Informe um endereço de e-mail válido');
      break;

    case 'Valor inválido.':
      messageI18n = t('Valor inválido');
      break;

    case 'Número de telefone inválido.':
      messageI18n = t('Número de telefone inválido');
      break;

    case 'Senhas devem ser iguais.':
      messageI18n = t('Senhas devem ser iguais');
      break;

    case 'Senha deve conter ao menos 8 caracteres.':
      messageI18n = t('Senha deve conter ao menos 8 caracteres');
      break;

    case 'CNPJ é inválido.':
      messageI18n = t('CNPJ é inválido');
      break;

    default:
      messageI18n = null;
  }

  return (
    (messageI18n && (
      <Text size="sm" color={'destructive_400'} as="span">
        {error === 'Required' ? 'VALIDATION_MESSAGES.required' : messageI18n}
      </Text>
    )) ||
    null
  );
};

export default FeedbackError;
